import React, { useReducer } from 'react'
import CommonContext from './commonContext'
import CommonReducer from './commonReducer'
import { apiCall } from '@/product/common/api'
import { response } from '@/product/context/common'

import {
    COMMON_VALUES,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    DRAFT_PAGE_FILTERS,
} from './commonTypes'

const CommonState = (props) => {
    const initialState = {
        allCategory: [],
        allLocations: [],
        allCondition: [],
        allNotifications: [],
        allConfigurationVariables: {},
        allBidIncrements: [],
        alldata_all_dropdown: [],
        allUi: [],
        responseStatus: null,
        allTaxCodeList: [],
        allHomeBanner: [],
        allMaintanenceData: {},
        draft_page_filters: {
            page: 1,
            limit: global?.zb_custom_table_limit || 10,
            order: '',
            orderby: 'p.created_at, asc',
            timeZone: Intl.DateTimeFormat().resolvedOptions(),
            fetchImage: true,
            filters: {
                action: {
                    value: 'draft',
                    type: 'in',
                    field: 'p.market_status',
                },
                status: {
                    value: [],
                    type: 'array',
                    field: 'p.status',
                },
                delete_status: {
                    value: 'delete',
                    type: 'notin',
                    field: 'p.status',
                },
                location_id: {
                    value: [],
                    type: 'array',
                    field: 'p.location_id',
                },
                employee_id: {
                    value: [],
                    type: 'array',
                    field: 'p.user_id',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'p.title,p.desc_proc,p.item_id,it.keywords,it.bin_location,it.truck_code,it.warehouse_name,it.scan_lpn_number,it.asin,it.mpn,it.upc,it.brand,it.category_text',
                },
                fromdate: {
                    value: '',
                    type: 'datestartgreaterequal',
                    field: 'p.created_at',
                    withTime: true,
                },
                todate: {
                    value: '',
                    type: 'dateendsmallerequal',
                    field: 'p.created_at',
                    withTime: true,
                },
            },
        },
    }

    const [state, dispatch] = useReducer(CommonReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getGlobalVariable = async (type) => {
        const [res] = await Promise.all([
            apiCall('post', 'getDefault', {}, '', '', true),
        ])
        if (res.data.status === 'success') {
            console.log('res.data', res.data)
            dispatch({
                type: COMMON_VALUES,
                payload: {
                    allCategory:
                        res.data.data.responseData.tableValues.allcategorytypes.filter(
                            (value) => value.active != 2
                        ),
                    allNotifications:
                        res.data.data.responseData.tableValues
                            .allall_notifications,
                    allConfigurationVariables:
                        res.data.data.responseData.variables,
                    allLocations:
                        res.data.data.responseData.tableValues.alllocations.filter(
                            (value) => value.active != 2
                        ),
                    allCondition:
                        res.data.data.responseData.tableValues.allconditiontypes.filter(
                            (value) => value.active != 2
                        ),
                    allMaintanenceData:
                        res.data.data.responseData.maintanenceData,
                    alldata_all_dropdown: res.data.data.responseData.tableValues
                        .alldata_all_dropdown
                        ? res.data.data.responseData.tableValues.alldata_all_dropdown.filter(
                              (value) => value.active != 2
                          )
                        : [],
                    allUi: res.data.data.responseData.tableValues
                        .allui_settings,
                    allBidIncrements:
                        res.data.data.responseData.allBidIncrements,
                    bidIncrementDefault:
                        res.data.data.responseData.bidIncrementDefault,
                    allTaxCodeList:
                        res.data.data.responseData.tableValues.alltax_code_list,
                    allHomeBanner:
                        res.data.data.responseData.tableValues.allhome_banner,
                },
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    const updateDraftPageFilters = (filters) => {
        dispatch({
            type: DRAFT_PAGE_FILTERS,
            payload: filters,
        })
    }
    const restockingFeeUpdate = async (formData) => {
        try {
            const from = 'restockingFeeUpdate'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'restockingFeeUpdate',
                    formData,
                    '',
                    'user',
                    '',
                    true
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    return (
        <CommonContext.Provider
            value={{
                allCategory: state.allCategory,
                allNotifications: state.allNotifications,
                allLocations: state.allLocations,
                allCondition: state.allCondition,
                allBidIncrements: state.allBidIncrements,
                allUi: state.allUi,
                allConfigurationVariables: state.allConfigurationVariables,
                alldata_all_dropdown: state.alldata_all_dropdown,
                responseStatus: state.responseStatus,
                allTaxCodeList: state.allTaxCodeList,
                allHomeBanner: state.allHomeBanner,
                allMaintanenceData: state.allMaintanenceData,
                draft_page_filters: state.draft_page_filters,
                updateDraftPageFilters,
                getGlobalVariable,
                clearResponse,
                restockingFeeUpdate,
            }}
        >
            {props.children}
        </CommonContext.Provider>
    )
}

export default CommonState
